import apiClient from 'api/config/apiClient'

export default {
  getOutpatientAuthorizationsProviderResult(payload) {
    return apiClient.request('authorization_provider', payload)
  },
}
